import { Box, Skeleton } from '@mui/material'

const CompanyCardSkeleton = ({ size = 4 }) => (
  <>
    {Array.from({ length: size }).map((_, index) => (
      <Box key={index} sx={styles.singleCard}>
        <Box sx={styles.infoUnit}>
          <Skeleton variant="text" width={100} height={18} sx={styles.label} />
          <Skeleton variant="text" width="70%" height={24} sx={styles.value} />
        </Box>
        <Box sx={styles.infoUnit}>
          <Skeleton variant="text" width={110} height={18} sx={styles.label} />
          <Skeleton variant="text" width="60%" height={24} sx={styles.value} />
        </Box>
        <Box sx={styles.infoUnit}>
          <Skeleton variant="text" width={120} height={18} sx={styles.label} />
           <Skeleton variant="text" width="60%" height={24} sx={styles.value} />
        </Box>
        <Box sx={styles.infoUnit}>
          <Skeleton variant="text" width={56} height={18} sx={styles.label} />
          <Skeleton variant="text" width={88} height={24} sx={styles.value} />
        </Box>
        <Box sx={styles.actionArea}>
          <Skeleton variant="rounded" width={40} height={40} />
        </Box>
      </Box>
    ))}
  </>
)

const styles = {
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: '20px',
    paddingRight: { xs: '0px', sm: '50px' },
    margin: '10px 0',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    flexDirection: { xs: 'column', sm: 'row' },
    position: { xs: 'relative', sm: 'unset' },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: '100%',
    width: '100%',
    minWidth: 0,
    alignItems: { xs: 'flex-start', md: 'center' },
    marginBottom: { xs: '8px', md: '0px' },
  },
  label: {
    marginRight: { xs: '10px', md: '0px' },
    marginBottom: { md: '10px' },
  },
  value: {
    maxWidth: '100%',
  },
  modulesRow: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  actionArea: {
    position: { xs: 'absolute', md: 'unset' },
    top: { xs: '10px', md: 'unset' },
    right: { xs: '12px', md: 'unset' },
    alignSelf: { md: 'center' },
  },
}

export default CompanyCardSkeleton
